import { defineMessages, MessageDescriptor } from 'react-intl';

/**
 * Centralized mention confidence/status translation messages.
 * Use with FormattedMessage or formatMessage so the extractor picks up the ids and defaultMessages.
 *
 * @example
 * <FormattedMessage {...liveMentionStatusMessages[value]} />
 */
export const mentionStatusMessages: Record<string, MessageDescriptor> = defineMessages({
  ACCEPTED: {
    id: 'audit.liveMentions.status.ACCEPTED',
    defaultMessage: 'Aceptada',
  },
  AUTO: {
    id: 'audit.liveMentions.status.AUTO',
    defaultMessage: 'Auto',
  },
  MANUAL: {
    id: 'audit.liveMentions.status.MANUAL',
    defaultMessage: 'Manual',
  },
  REJECTED: {
    id: 'audit.liveMentions.status.REJECTED',
    defaultMessage: 'Rechazada',
  },
});
